module.exports = __webpack_public_path__ + "static/media/s3Logo.22e6f50d.svg";